module.exports = "/images/icon_register_white.svg?7dc0f43c1eefeed5ed8be9890889894f";